import cn from 'classnames'

import type { IFieldBaseRenderProps } from 'components/formKit/types'
import { testProps } from 'utils/test/qaData'

import * as s from './LabelResetInherit.module.scss'
import { useResetInherit } from './useResetInherit'

const LabelResetInherit: React.FC<IFieldBaseRenderProps> = ({ config, configs }) => {
  const [isValue, onReset] = useResetInherit(config, configs)

  if (!config.label) {
    return null
  }

  return (
    <div
      {...testProps({ el: 'resettableLabel', label: config.label })}
      className={cn(s.label, { [s.active]: isValue })}
      onClick={onReset}
    >
      {config.label}
    </div>
  )
}
export default LabelResetInherit
